<template>
  <Note
    v-if="message"
    variant="error"
  >
    <div>
      <div
        ref="scrollRef"
        class="absolute top-[-10px]"
      />
      {{ message }}
    </div>
    <template v-if="issues && issues.length > 0">
      <ul class="mt-2 text-sm list-disc list-inside">
        <li
          v-for="issue in issues"
          :key="issue"
          class="p-0"
        >
          {{ issue }}
        </li>
      </ul>
    </template>
  </Note>
</template>
<script setup lang="ts">
import Note from '@/components/note.vue';
import { getErrorIssuesMessages, getErrorMessage } from '@/lib/http';
import {
  computed,
  nextTick,
  ref, watch,
} from 'vue';

const scrollRef = ref<HTMLElement | null>(null);

function isInViewport(el: HTMLElement): boolean {
  const rect = el.getBoundingClientRect();
  const topBoundary = (window.innerHeight || document.documentElement.clientHeight);
  return (
    rect.top >= 0 && rect.bottom <= topBoundary
  );
}

const props = defineProps<{
  error: unknown;
}>();

const message = computed(() => getErrorMessage(props.error));
const issues = computed(() => {
  const msgs = getErrorIssuesMessages(props.error);
  if (msgs[0] === message.value && msgs.length === 1) {
    return [];
  }
  return msgs;
});

watch(
  () => props.error,
  async (newVal) => {
    if (!newVal) {
      return;
    }
    await nextTick(); // wait for DOM to render
    if (!scrollRef.value) {
      return;
    }
    if (!isInViewport(scrollRef.value)) {
      scrollRef.value.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  },
  { immediate: true },
);

</script>
